
<div class="create-buttons" *ngIf="noFlowchart &&!statsMode">
	<button class="button" *ngIf="project?.subtype !== 'simple'" (click)="createNew()">
		<i class="fa fa-plus"></i> {{ 'CREATE_FLOWCHART' | translate }}
	</button>
	<button class="button" *ngIf="haveProjectStepsStats" (click)="createNew(true)">
		<i class="fa fa-plus"></i> {{ 'GENERATE_FLOWCHART' | translate }}
	</button>
</div>

<!-- undo/redo button -->
<bb-state-history *ngIf="!statsMode" [displayVersions]="false"></bb-state-history>

<!-- <pre class="debug" style="z-index: 999999; bottom: 40px; width: auto; background: #f0f0f0;">
	toStep {{ toStep?.id }}
	mouseOverPlaceholder {{ mouseOverPlaceholder }}
	mouseOverPlaceholderTimeout {{ mouseOverPlaceholderTimeout }}
	currentMouseOverStep {{ currentMouseOverStep }}
	mouseOutTimeout {{ mouseOutTimeout }}
	newStep.x {{ newStep.x }}
</pre> -->

<div class="scroller" [class.stats-mode]="statsMode" #scrollerEl>
<flowchart-columns
	[ngStyle]="{
		width: (canvasStatus?.zoom * flowchart?.chapters?.length * (gridRules.x.track + gridRules.x.gutter)) + 'px',
		left: canvasStatus?.left + 'px'
	}"
	[zoom]="canvasStatus?.zoom"
	[allowEdit]="!statsMode"
	[highlight]="highlightCols">
</flowchart-columns>

<bb-canvas 
	*ngIf="flowchart && ! noFlowchart"
	(initialized)="canvasInitialized = true"
	(zoomChange)="onZoomChange($event)"
	[zoomToFit]="true"
	[dragDisabled]="drawing || dragging || canvasDragDisabled"
	#flowchartZoomCanvasRef
	class="project-stats-canvas"
>
	<div
		*ngIf="flowchart"
		class="flowchart-canvas"
		[class.drawing]="drawing"
		[class.mouse-over-step]="overStep"
		(dblclick)="canvasDblclick($event)"
		(click)="canvasClick($event)"
		(contextmenu)="canvasContextMenu($event)"
		(mousemove)="canvasMouseMove($event)"
		(mouseout)="canvasMouseOut($event)"
		(mouseover)="canvasMouseOver($event)"
		[ngStyle]="{width: flowchartSize.width + 'px', height: flowchartSize.height + 'px'}"
	>
		<bb-drag-selector *ngIf="canvasDragDisabled" [hidden]="dragging" (selectDragging)="onSelectDragging($event)" (selectDragEnd)="onSelectDragEnd()"></bb-drag-selector>
		<bb-context-menu *ngIf="!statsMode" [ngStyle]="contextMenuStyle" [options]="contextMenuOptions" (optionSelected)="contextMenuOptionSelected($event)" (clickOutside)="contextMenuHide()"></bb-context-menu>
		
		<div class="svg-wrapper" #svgWrapper>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" #svg>
				<defs>
					<marker id="arrowhead" viewBox="0 0 10 10" refX="3" refY="5" markerWidth="6" markerHeight="6" orient="auto" fill="#7AB1DF">
						<path d="M 0 0 L 10 5 L 0 10 z" stroke-width="1"></path>
					</marker>
					<marker id="statsTextBackground" viewBox="0 0 10 10" refX="3" refY="5" markerWidth="50" markerHeight="20" orient="auto" fill="#7AB1DF">
						<rect fill="#f0f" stroke="#000" stroke-width="1.5" width="50" height="20"></rect>
					</marker>
					<marker id="mid_arrow" markerWidth="2" markerHeight="2" viewBox="-1 -1 2 2" orient="auto">
						<path fill="blue" d="M-1,-1 L1,0 -1,1 z" />
					</marker>
					<marker id="lineSelector" viewBox="0 0 10 10" refX="3" refY="5" markerWidth="50" markerHeight="20" orient="auto" fill="#7AB1DF">
						<rect fill="#f0f" stroke="#000" stroke-width="1.5" width="50" height="20"></rect>
					</marker>
					<filter id="dropshadow" height="130%">
						<feGaussianBlur in="SourceAlpha" stdDeviation="1"/> <!-- stdDeviation is how much to blur -->
						<feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
						<feComponentTransfer>
							<feFuncA type="linear" slope="0.15"/> <!-- slope is the opacity of the shadow -->
						</feComponentTransfer>
						<feMerge> 
							<feMergeNode/> <!-- this contains the offset blurred image -->
							<feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
						</feMerge>
					</filter>
					<filter id="testflood">
						<feFlood flood-color="#7AB1DF" flood-opacity="1" result="flood"/>
						<feComposite in="flood" in2="blur" operator="in" result="composite"/>
						<feMerge result="merge">
							<feMergeNode in="composite" result="mergeNode"/>
							<feMergeNode in="SourceGraphic" result="mergeNode1"/>
						</feMerge>
					</filter>
					<linearGradient id="three_opacity_stops" gradientTransform="rotate(90)">
						<stop offset="0%" [style.stop-color]="dropoffColor" style="stop-opacity: 1;"/>
						<stop offset="30%" [style.stop-color]="dropoffColor" style="stop-opacity: 0.5;"/>
						<stop offset="60%" [style.stop-color]="dropoffColor" style="stop-opacity: 0;"/>
						<stop offset="100%" [style.stop-color]="dropoffColor" style="stop-opacity: 0;"/>
					</linearGradient>
					<linearGradient id="three_opacity_stops_mo" gradientTransform="rotate(90)">
						<stop offset="0%" [style.stop-color]="dropoffColorMo" style="stop-opacity: 1;"/>
						<stop offset="30%" [style.stop-color]="dropoffColorMo" style="stop-opacity: 0.5;"/>
						<stop offset="60%" [style.stop-color]="dropoffColorMo" style="stop-opacity: 0;"/>
						<stop offset="100%" [style.stop-color]="dropoffColorMo" style="stop-opacity: 0;"/>
					</linearGradient>
					<filter id="shadow2" x="-20%" y="-20%" width="140%" height="140%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="linearRGB">
						<feOffset dx="2" dy="2" in="SourceAlpha" result="offset"/>
						<feGaussianBlur stdDeviation="2 2" in="offset" result="blur"/>
						<feFlood flood-color="#000000" flood-opacity="1" result="flood"/>
						<feComposite in="flood" in2="blur" operator="in" result="composite"/>
						<feMerge result="merge">
							<feMergeNode in="composite" result="mergeNode"/>
							<feMergeNode in="SourceGraphic" result="mergeNode1"/>
						</feMerge>
					</filter>
					<filter id="strokefilter" x="-20%" y="-20%" width="140%" height="140%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="linearRGB">
						<feMorphology operator="dilate" radius="3 3" in="SourceAlpha" result="morphology"/>
						<feFlood flood-color="#7AB1DF" flood-opacity="1" result="flood"/>
						<feComposite in="flood" in2="morphology" operator="in" result="composite"/>
						<feMerge result="merge">
							<feMergeNode in="composite" result="mergeNode"/>
							<feMergeNode in="SourceGraphic" result="mergeNode1"/>
						</feMerge>
					</filter>
				</defs>

				<!-- All lines connecting steps -->
				<g
					*ngFor="let line of lines | objectAsArray | orderBy : ['-statsIndex']; trackBy: trackBy"
					fill="none"
					[attr.line-id]="line.id"
					(click)="clickLine(line, $event)"
					(contextmenu)="lineContextMenu(line, $event)"
					(mouseover)="currentMouseOverLink = line.id"
					(mouseout)="currentMouseOverLink = null"
					[ngStyle]="{ 'pointer-events' : selectDragging || drawing || dragging ? 'none' : 'all'}"
					style="cursor: pointer;"
				>
					<!-- Larger clickable area for thin lines (width 15) -->
					<path [ngStyle]="{opacity: 0}" [attr.stroke]="'#FFFFFF'" [attr.stroke-width]="15" [attr.d]="line.d"
						[attr.title]="line.id">
					</path>
					<!-- Main line -->
					<path 
						[style.stroke]="statsMode && line?.isDropoff ? 'url(#three_opacity_stops' : ''"
						[attr.stroke]="(this.currentMouseOverLink === line.id || this.selection.items[line.id]) ? '#7AB1DF' : line.strokeColor"
						[attr.stroke-width]="line.strokeWidth"
						[attr.id]="line.id" [attr.d]="line.d"
						[attr.stroke-dasharray]="line.strokeWidth === 2.01 ? 4 : 0"
						[attr.title]="line.id"
					>
					</path>
					<!-- Show count for each selected line (highlight layers won't show all counts when selected multiple) -->
					<g [attr.data-currentMouseOverLink]="currentMouseOverLink" [attr.data-lineid]="line.id">
						<text dy="-1" *ngIf="statsMode && (currentMouseOverLink === line.id || selection.items[line.id])">
							<textPath style="pointer-events: none;" *ngIf="line.strokeWidth" [attr.xlink:href]="'#' + line.id" text-anchor="middle" startOffset="50%" class="line-text-label" fill="white" filter="url(#strokefilter)">
								{{ line.count }} ➤
							</textPath>
						</text>
					</g>
				</g>

				<!-- The highlight layers for statsMode, which are seperate so they are on top of the grey lines -->
				<ng-container *ngTemplateOutlet="linkHighlight; context: {line: highlightLine}"></ng-container>
				<ng-container *ngTemplateOutlet="linkHighlight; context: {line: lines[currentMouseOverLink]}"></ng-container>
				<ng-template #linkHighlight	let-line="line">
					<g fill="none" *ngIf="statsMode && line" [attr.line-id]="line.id" style="pointer-events: none;">
						<path 
							[style.stroke]="line?.isDropoff ? 'url(#three_opacity_stops_mo)' : ''"
							[attr.stroke]="(this.currentMouseOverLink === line.id || this.selection.items[line.id]) ? '#7AB1DF' : line.strokeColor"
							[attr.stroke-width]="line.strokeWidth"
							[attr.id]="line.id + '_highlight'" [attr.d]="line.d"
							[attr.stroke-dasharray]="line.strokeWidth === 2.01 ? 4 : 0"
							[attr.title]="line.id + '_highlight'"
						>
						</path>
						<path 
							*ngIf="!line?.isDropoff" [ngStyle]="{opacity: selection.items[line.id] ? 0 : 0}"
							[attr.stroke]="'#FFFFFF'" [attr.stroke-width]="1.5"	[attr.d]="line.d" [attr.title]="line.id"
						>
						</path>
						<g [attr.data-currentMouseOverLink]="currentMouseOverLink" [attr.data-lineid]="line.id">
							<text dy="-1">
								<textPath style="pointer-events: none;" *ngIf="line.strokeWidth" [attr.xlink:href]="'#' + line.id + '_highlight'" text-anchor="middle" startOffset="50%" class="line-text-label" fill="white" filter="url(#strokefilter)">
									{{ line.count}} ➤
								</textPath>
							</text>
						</g>
					</g>
				</ng-template>
			</svg>
		</div>

		<div class="steps-wrapper">
			<!-- Dummy step shown when dragging (with (+) button) to create a new step -->
			<div class="ghost-step" [hidden]="toStep || !ghostStep.x" [ngStyle]="{
						left: ( ghostStep.x ) + 'px',
						top: ( ghostStep.y ) + 'px',
						width: ( ghostStep.width ) + 'px',
						height: ( ghostStep.height ) + 'px',
						'border-width': ( ghostStep.border ) + 'px'
					}">
				<span class="new-text" [hidden]="!draggingNew">
					{{ 'NEW' | translate }}
				</span>
			</div>

			<!-- Clone which is shown when dragging an existing step -->
			<flowchart-step
				*ngIf="zoomOfsettedStepClone"
				class="step"
				[step]="zoomOfsettedStepClone"
				[statsMode]="statsMode"
				[selected]="selection?.items[zoomOfsettedStepClone?.id]"
				[class.text-selected]="highlightStepText && selection.items[zoomOfsettedStepClone.id]"
				[class.dragging]="zoomOfsettedStepClone.dragging"
				[class.start-step]="zoomOfsettedStepClone.isStart"
				[class.stats-mode]="statsMode"
				[class.selected]="selection && selection.items && zoomOfsettedStepClone && selection.items[zoomOfsettedStepClone.id]"
				[style.left]="zoomOfsettedStepClone.x - (zoomOfsettedStepClone.width / 2) + 'px'"
				[style.top]="zoomOfsettedStepClone.y - (zoomOfsettedStepClone.height / 2) + 'px'"
				style="pointer-events: none;">
			</flowchart-step>

			<!-- The (+) sign when hovering a step -->
			<div 
				*ngIf="!statsMode && newStep"
				class="placeholder-step"
				interactDraggable
				[interactSnapObjectSubject]="snapObjectSubject"
				(interactDragStart)="onNewClick($event)"
				(interactDragEnd)="canvasClick($event)"
				(mouseover)="setPlaceholderMouseOver(true)"
				(mouseout)="setPlaceholderMouseOver(false)"
				[ngStyle]="{ left: ( newStep.x ) + 'px', top: ( newStep.y ) + 'px' }"
				[style.pointer-events]="selectDragging || drawing || dragging ? 'none' : 'all'"
				[class.show-plus]="!toStep && !drawing"
				[class.dragging]="drawing"
				[hidden]="!fromStep || (toStep && drawing) || draggingNew"
				(click)="onNewClick($event);stopPropagation($event)"
			>
				<div class="add">+</div>
			</div>

			<!-- All steps in the flowchart -->
			<flowchart-step
				*ngFor="let step of flowchart.steps | objectAsArray; trackBy: trackBy"
				class="step"
				fileDroppable
				(onFilesDropped)="stepFilesDropped(step, $event)"
				[disableDrag]="disableDragging"
				[step]="step"
				[statsMode]="statsMode"
				[selected]="selection?.items[step?.id]"
				interactDraggable
				(interactDragStart)="onStepDragStart(step, $event)"
				(interactDragging)="onStepDragging(step, $event)"
				(interactDragEnd)="onStepDragEnd(step, $event)"
				(click)="stepClick(step, $event)"
				(contextmenu)="stepContextMenu(step, $event)"
				(dblclick)="stepDblclick(step, $event)"
				(mouseover)="stepMouseOver(step)"
				(mousedown)="stepMousedown(step, $event)"
				(mousemove)="stepMouseMove(step, $event)"
				(mouseout)="stepMouseOut(step)"
				[class.text-selected]="highlightStepText && selection.items[step.id]"
				[class.dragging]="step.dragging"
				[class.start-step]="step.isStart"
				[class.stats-mode]="statsMode"
				[class.selected]="selection && selection.items && step && selection.items[step.id]"
				[class.is-drop-target]="drawing && step?.id === toStep?.id"
				[style.opacity]="zoomOfsettedStepClone?.id === step?.id ? 0 : 1"
				[style.left]="step.x + 'px'"
				[style.top]="step.y + 'px'"
				[ngStyle]="{'pointer-events' : (statsMode && dragging) || selectDragging || (drawing && step?.id === fromStep?.id) ? 'none' : 'all' }">
			</flowchart-step>
		</div>
	</div>
</bb-canvas>
</div>

<!-- Sidebar (hidden in statsMode) -->
<form #formRef="ngForm" name="inspector-form" class="inspector-form" (submit)="inspectorFormSubmit($event)" (keydown)="inspectorFormKeyDown($event)" *ngIf="!statsMode">
	<div class="inspector">
		<div class="selection-box">
			<div class="no-step-selected" *ngIf="!selection.count">
				<h3>{{ 'NO_ITEMS_SELECTED' | translate }}</h3>
			</div>
			<div class="step-inspector-title" *ngIf="selection.count > 1">
				<h3>
					{{ (selection.count === 1 ? 'ONE_ITEM_SELECTED' : 'X_ITEMS_SELECTED') | translate : { x: selection.count } }}
				</h3>
			</div>
			<div class="step-inspector" *ngIf="selection && selection.count > 1">
				<button class="button" (click)="deleteItems(selection.items)"><i class="fa fa-trash"></i> {{ 'DELETE_SELECTED_ITEMS' | translate }}</button>
			</div>
			<div class="step-inspector" *ngIf="selection.single">
				<div *ngIf="selection.single.type === 'FlowchartLink'">
					<h3>{{ 'SELECTED_LINK' | translate }}:</h3>
					<button class="button" (click)="deleteItems(selection.items)"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
				</div>
				<div *ngIf="selection.single.type === 'FlowchartStep'">
					<h3>{{ 'SELECTED_STEP' | translate }}:</h3>
						<div class="inspector-form-row">
							<input [(ngModel)]="selection.single.description" type="text" name="step_description" #stepDescriptionInputRef (input)="stepDescriptionChanged(selection.single)" />
						</div>
						<div *ngIf="selection.single.entityType === 'mediaclip'">
							<div class="inspector-form-row">
								<label>
									<div class="label">{{ 'MEDIACLIP' | translate }}
										<span (click)="useClipTitleAsStepTitle(selection.single, selection.entity, true)" [title]="'USE_TITLE' | translate" [hidden]="!selection.single.entityId">&nbsp;&nbsp;<i class="fa fa-long-arrow-up"></i>&nbsp;&nbsp; </span>
										<ng-container *ngIf="selection?.entity?.id && (!selection?.entity?.timelines || !selection?.entity?.timelines[0])">
											<a class="edit-interactivity-button" [title]="'ADD_INTERACTIVITY' | translate" [routerLink]="['/library/interactivity/new']" [queryParams]="{ parentEntityType: 'MediaClip', parentEntityId: selection?.entity?.id}">
												<i class="fa fa-object-group"></i>
											</a>
										</ng-container>
										<ng-container *ngIf="selection?.entity?.timelines && selection?.entity?.timelines[0]">
											<a class="edit-interactivity-button" [title]="'EDIT_INTERACTIVITY' | translate" [routerLink]="['/library/interactivity/' + selection?.entity?.timelines[0].id]">
												<i class="fa fa-object-group"></i>
											</a>
										</ng-container>
									</div>
									<bb-entity-selector 
										[(ngModel)]="selection.single.entityId"
										name="step_entityId"
										entityType="commonclip"
										[filterSet]="clipSelectorFilterSet"
										(optionSelected)="onStepClipSelected($event)"
									></bb-entity-selector>
								</label>
							</div>
							<div class="inspector-form-row">
								<bb-player *ngIf="selection.entity"
									[mediaclip]="selection.entity"
									[autoplay]="false"
								></bb-player>
							</div>
						</div>
							
						<label hidden class="inspector-form-row">
							<div>left / top</div>
							<input [(ngModel)]="selection.single.x" type="number" name="step_x" /> <input [(ngModel)]="selection.single.y" type="number" name="step_y" />
						</label>
						<div class="inspector-form-row">
							<button [class.disabled]="!project?.noIntroClip && selection.single.isStart" class="button" (click)="deleteStep(selection.single)"><i class="fa fa-trash"></i> {{ 'DELETE_STEP' | translate }}</button>
						</div>
						<input [(ngModel)]="selection.single.id" type="hidden" name="step_id" />
				</div>
			</div>
		</div>

		<div class="sidebar-box" *ngIf="project">
			<bb-kpi-performance [project]="project" [mode]="'sidebar'" *ngIf="entity?.kpiCalculations?.length"></bb-kpi-performance>
			<bb-checklist [items]="checklistItems"></bb-checklist>
			<bb-sidebar-details [project]="project" [mainMediaClip]="mainMediaClip">
			</bb-sidebar-details>
		</div>
	</div>
</form>
